"use client";
import React from "react";

export const HoverBorderGradient = ({
  children,
  containerClassName,
  className,
  as: Component = "button",
  ...props
}) => {
  return (
    <div className={`relative rounded-lg p-[1px] overflow-hidden ${containerClassName}`}>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 hover:opacity-100 transition-opacity duration-300" />
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-70 group-hover:opacity-0 blur-xl transition-opacity duration-300" />
      <Component
        className={`relative bg-white dark:bg-gray-900 rounded-lg py-3 px-6 text-sm font-medium transition-all duration-300 ${className}`}
        {...props}
      >
        {children}
      </Component>
    </div>
  );
}; 